<template>
  <v-card class="mx-auto overflow-hidden" width="600">
    <v-form
      ref="form"
      v-model="valid"
      :lazy-validation="lazy"
      autocomplete="off"
    >
      <v-card-text>
        <div class="pb-4 subtitle-1">{{ $t("informPassword") }}</div>
        <v-text-field
          :class="[show ? 'show-password' : 'hide-password']"
          v-model="form.currentPassword"
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          type="text"
          :label="$t('currentPassword')"
          solo-inverted
          @click:append="show = !show"
          required
          clearable
          name="oldPassword"
          tabindex="10"
          autocapitalize="off"
          :error="errorCurrentPassword"
          autofocus
        ></v-text-field>
        <div class="pb-4 subtitle-1">{{ $t("oldPassword") }}</div>
        <v-text-field
          :class="[show1 ? 'show-password' : 'hide-password']"
          v-model="form.newPassword"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          type="text"
          :label="$t('newPassword')"
          :hint="$t('rulePassword')"
          :rules="[rules.passMin, rules.passCaracter, rules.max]"
          solo-inverted
          clearable
          @click:append="show1 = !show1"
          required
          name="newPassword"
          tabindex="11"
          autocapitalize="off"
          :error="errorNewPassword"
          :counter="8"
          maxlength="8"
        ></v-text-field>
        <v-text-field
          :class="[show2 ? 'show-password' : 'hide-password']"
          v-model="form.confirmNewPassword"
          :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
          type="text"
          :label="$t('confirmPassword')"
          :rules="passMatch"
          solo-inverted
          clearable
          @click:append="show2 = !show2"
          required
          name="confirmNewPassword"
          tabindex="12"
          autocapitalize="off"
          :error="errorNewPassword"
          :counter="8"
          maxlength="8"
        ></v-text-field>
      </v-card-text>
      <v-card-actions class="pa-4 pt-0">
        <v-spacer></v-spacer>
        <v-btn
          depressed
          color="info"
          :loading="loading"
          v-on:click.prevent="changePassword"
          type="submit"
          :disabled="!valid"
          tabindex="14"
          >{{ $t("changePassword") }}</v-btn
        >
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import qs from "qs";
import { validate } from "@/util/form-validate.js";
export default {
  name: "profile",
  data: () => ({
    valid: true,
    lazy: false,
    show: false,
    show1: false,
    show2: false,
    loading: false,
    form: {},
    hash: "",
    errorCurrentPassword: false,
    errorNewPassword: false,
    rules: {
      required: validate.required,
      passMin: validate.passMin,
      passCaracter: validate.passCaracter,
      max: validate.max,
    },
    confirmNewPassword: "",
    checkPasswordRules: {
      required: "Este campo é obrigatório.",
    },
  }),
  created() {
    this.checkPasswordRules.required = this.$t("requiredInput");
  },
  watch: {
    "form.currentPassword"() {
      this.errorCurrentPassword = false;
    },
    "form.confirmNewPassword"() {
      this.errorNewPassword = false;
    },
  },
  computed: {
    // Repet password
    passMatch() {
      const rules = [];
      // Required
      if (this.checkPasswordRules.required) {
        const rule = (v) => !!v || this.$t("requiredInput");
        rules.push(rule);
      }
      if (this.form.confirmNewPassword) {
        const rule = (v) =>
          (!!v && v) === this.form.newPassword || this.$t("repeatPassword");
        rules.push(rule);
      }
      return rules;
    },
  },
  methods: {
    changePassword() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const { currentPassword, newPassword, confirmNewPassword } = this.form;

        if (newPassword == confirmNewPassword) {
          const password = {
            password: currentPassword,
          };

          this.$axios
            .post("/agent/profile/confirmPassword", this.$formdata(password))
            .then(async (resp) => {
              this.hash = await resp.data.dados.hash;
            })
            .then(() => {
              const objNewPassword = {
                hash: this.hash,
                password: newPassword,
              };

              this.$axios
                .put(
                  "/agent/profile/editPassword",
                  qs.stringify(objNewPassword)
                )
                .then((resp) => {
                  // alert(resp.data.messages);
                  // alert feedback snack
                  this.$store.commit("setFeedbackSnack", {
                    msg: resp.data.messages,
                    color: "success",
                  });
                  this.$refs.form.reset();
                  this.$refs.form.resetValidation();
                })
                .catch(() => {
                  this.errorNewPassword = true;
                });
            })
            .catch(() => {
              this.errorCurrentPassword = true;
            })
            .finally(() => (this.loading = false));
        }
      }
    },
  },
};
</script>
